import Phaser from 'phaser';
import $ from 'jquery';
import { CST } from '../CST';

var User_ID = Math.floor(Math.random() * 9999999 + 1);

export default class Menu extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.MENU);
	}

	preload() {
		this.link =
			'https://docs.google.com/forms/d/e/1FAIpQLScDqr7oznDCBfupTAyfpcdvcH--QOekQkNAMjNN-TWfrgzdYw/viewform';
	}

	create() {
		this.clickSound = this.sound.add('click-sound');

		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'menu-bg');

		this.playBtn = this.add
			.image(this.cameras.main.width / 2 + 230, this.cameras.main.height / 2 - 80, 'play-btn')
			.setScale(0.5)
			// .setDepth(0)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				setFullScreen();

				this.clickSound.play();
				sendUserDataToDatabase();
				this.scene.start(CST.SCENES.UISCENE, {
					User_ID: User_ID,
				});
			});
		// .setVisible(false);

		// this.feedbackBtn = this.add
		// 	.image(this.cameras.main.width / 2 + 230, this.cameras.main.height / 2 - 80, 'feedback-btn')
		// 	.setInteractive({
		// 		useHandCursor: true,
		// 	})
		// 	.on('pointerdown', () => {
		// 		this.clickSound.play();
		// 		this.feedbackBtn.destroy();
		// 		this.playBtn.setVisible(true);
		// 		openExternalLink(this.link);
		// 	});

		this.add
			.image(this.cameras.main.width / 2 + 230, this.cameras.main.height / 2, 'rules-btn')
			.setScale(0.5)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				this.scene.pause(),
					this.scene.launch(CST.SCENES.RULES, {
						scene: CST.SCENES.MENU,
					});
			});

		this.add
			.image(this.cameras.main.width / 2 + 230, this.cameras.main.height / 2 + 80, 'credits-btn')
			.setScale(0.5)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				this.clickSound.play();
				this.scene.pause(),
					this.scene.launch(CST.SCENES.CREDITS, {
						scene: CST.SCENES.MENU,
					});
			});
	}
}

function detectMob() {
	return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function setFullScreen() {
	document.documentElement.requestFullscreen();
}

function sendUserDataToDatabase() {
	var userCorrectAnswer = {
		User_ID: User_ID,
	};

	//Sending JSON string to PHP file
	$.ajax({
		type: 'POST',
		// url: 'api/post-form-to-ddbb.php', // local
		url: 'website/post-form-to-ddbb.php', // live
		dataType: 'JSON',
		data: userCorrectAnswer,
	}).responseJSON;
}

function openExternalLink(link) {
	window.open(link, '_blank');
}
